<hawk-record-navigation [root]="'user'" [leafDescription]="'Sync-Konflikte der App'" class="app-page">
  <!-- Der Umschalter ist die einzige Steuerung der Seite und gehört deshalb in
       die Toolbar. -->
  <div slot="toolbar" class="flex flex-row gap-2 items-center">
    <button
      class="bm-btn bm-btn-sm"
      [class.bm-btn-primary]="scope === 'open'"
      (click)="setScope('open')"
    >
      Offen
      @if (overview) {
        <span class="bm-badge bm-badge-sm">{{ overview.open_count }}</span>
      }
    </button>
    <button
      class="bm-btn bm-btn-sm"
      [class.bm-btn-primary]="scope === 'resolved'"
      (click)="setScope('resolved')"
    >
      Erledigt
      @if (overview) {
        <span class="bm-badge bm-badge-sm">{{ overview.resolved_count }}</span>
      }
    </button>
    <button
      class="bm-btn bm-btn-sm"
      [class.bm-btn-primary]="scope === 'all'"
      (click)="setScope('all')"
    >
      Alle
    </button>
  </div>

  <div class="page-content page-frame overflow-auto">
    <div class="page-sheet max-w-7xl mx-auto flex flex-col gap-4">

      <div class="text-sm text-base-content/70">
        Änderungen der Techniker-App, die sich auf dem Server nicht anwenden ließen.
        Die Nutzdaten sind gesichert, die Upload-Queue des Geräts läuft weiter.
        Wiederholungen desselben Vorgangs stehen in einer Zeile zusammen.
      </div>

      @if (loading) {
        <div class="flex justify-center py-8">
          <span class="loading loading-spinner loading-lg"></span>
        </div>
      }

      @if (!loading && overview) {
        @for (group of overview.groups; track groupKey(group)) {
          <div class="bm-card bm-card-sm border border-base-300">
            <div class="bm-card-body">

              <div class="flex flex-row items-start justify-between gap-4">
                <div class="flex flex-col gap-1 min-w-0">
                  <div class="flex flex-wrap items-center gap-2">
                    <button class="bm-btn bm-btn-ghost bm-btn-xs" (click)="toggleGroup(group)">
                      <fa-icon [icon]="isExpanded(group) ? faChevronDown : faChevronRight"></fa-icon>
                    </button>
                    <span class="bm-card-title text-base">
                      {{ group.http_method }} {{ group.resource }}
                    </span>
                    @if (group.count > 1) {
                      <span class="bm-badge bm-badge-outline bm-badge-sm">
                        {{ group.count }}× wiederholt
                      </span>
                    }
                    @if (group.data_at_risk) {
                      <span class="bm-badge bm-badge-warning bm-badge-sm">Nutzdaten gesichert</span>
                    } @else {
                      <span class="bm-badge bm-badge-ghost bm-badge-sm">kein Datenverlust</span>
                    }
                    @if (group.resolved) {
                      <span class="bm-badge bm-badge-success bm-badge-sm">erledigt</span>
                    }
                  </div>

                  <div class="text-sm">{{ group.reason }}</div>

                  <div class="flex flex-wrap gap-x-4 gap-y-1 text-xs text-base-content/70">
                    <span>{{ typeLabel(group.conflict_type) }}</span>
                    <span>
                      {{ group.user?.name || "unbekannter Benutzer" }}
                      @if (group.user?.email) {
                        · {{ group.user?.email }}
                      }
                    </span>
                    @if (group.count > 1) {
                      <span>
                        {{ group.first_seen_at | date: "dd.MM.yyyy HH:mm" }}
                        bis {{ group.last_seen_at | date: "HH:mm" }}
                      </span>
                    } @else {
                      <span>{{ group.last_seen_at | date: "dd.MM.yyyy HH:mm" }}</span>
                    }
                    @if (group.resolved && group.resolved_by) {
                      <span>
                        abgehakt von {{ group.resolved_by?.name }}
                        am {{ group.resolved_at | date: "dd.MM.yyyy HH:mm" }}
                      </span>
                    }
                  </div>
                </div>

                <div class="shrink-0">
                  @if (group.resolved) {
                    <button
                      class="bm-btn bm-btn-sm"
                      [disabled]="isBusy(group)"
                      (click)="reopenGroup(group)"
                    >
                      <fa-icon [icon]="faUndo"></fa-icon>
                      Wieder öffnen
                    </button>
                  } @else {
                    <button
                      class="bm-btn bm-btn-sm bm-btn-primary"
                      [disabled]="isBusy(group)"
                      (click)="resolveGroup(group)"
                    >
                      <fa-icon [icon]="faCheck"></fa-icon>
                      Erledigt
                    </button>
                  }
                </div>
              </div>

              @if (isExpanded(group)) {
                <div class="overflow-x-auto mt-2">
                  <table class="bm-table bm-table-sm">
                    <thead>
                      <tr>
                        <th>Zeitpunkt</th>
                        <!-- Die Request-ID ist der direkte Einstieg ins
                             production.log — deshalb steht sie hier. -->
                        <th>Request-ID</th>
                        <th>Nutzdaten</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (conflict of group.conflicts; track conflict.id) {
                        <tr>
                          <td class="whitespace-nowrap">
                            {{ conflict.created_at | date: "dd.MM.yyyy HH:mm:ss" }}
                          </td>
                          <td class="font-mono text-xs">{{ conflict.request_id }}</td>
                          <td>
                            @if (conflict.has_payload) {
                              <button
                                class="bm-btn bm-btn-ghost bm-btn-xs"
                                [disabled]="isPayloadLoading(conflict.id)"
                                (click)="togglePayload(conflict.id)"
                              >
                                @if (payloadFor(conflict.id)) {
                                  ausblenden
                                } @else {
                                  anzeigen
                                }
                              </button>
                            } @else {
                              <span class="text-base-content/60">keine</span>
                            }
                          </td>
                        </tr>
                        @if (payloadFor(conflict.id)) {
                          <tr>
                            <td colspan="3">
                              @if (deviceFor(conflict.id)) {
                                <div class="text-xs text-base-content/70 mb-1">
                                  {{ deviceFor(conflict.id) }}
                                </div>
                              }
                              <pre
                                class="bg-base-200 rounded p-2 text-xs overflow-x-auto"
                              >{{ payloadFor(conflict.id) }}</pre>
                            </td>
                          </tr>
                        }
                      }
                    </tbody>
                  </table>
                </div>
              }
            </div>
          </div>
        }
        @empty {
          <div class="bm-alert text-sm">
            <fa-icon [icon]="faCheck"></fa-icon>
            <span>
              @if (scope === "open") {
                Keine offenen Sync-Konflikte.
              } @else {
                Keine Einträge in dieser Ansicht.
              }
            </span>
          </div>
        }
      }

      @if (!loading && !overview) {
        <div class="bm-alert bm-alert-warning text-sm">
          <fa-icon [icon]="faExclamationTriangle"></fa-icon>
          <span>Die Sync-Konflikte konnten nicht geladen werden.</span>
        </div>
      }
    </div>
  </div>
</hawk-record-navigation>
